import React from 'react';

const SegmentedControl = ({ label, options, selectedValue, onChange }) => {
  return (
    <div style={{ marginBottom: "25px" }}>
      <label style={{ display: "block", marginBottom: "10px", fontWeight: "bold", textTransform: "uppercase", fontSize: "14px", color: "#fff" }}>
        {label}
      </label>
      
      <div style={{ 
        display: "flex", 
        backgroundColor: "#111", 
        borderRadius: "6px", 
        padding: "4px", 
        border: "1px solid #333",
        gap: "4px" // Adds a tiny gap between buttons
      }}>
        {options.map((opt) => {
          const isActive = selectedValue === opt.id;
          return (
            <button
              key={opt.id}
              onClick={() => onChange(opt.id)}
              style={{
                flex: 1,
                padding: "12px 5px", // Reduced side padding slightly
                border: "none",
                borderRadius: "4px",
                backgroundColor: isActive ? "#D5A678" : "transparent",
                color: isActive ? "#000" : "#888",
                cursor: "pointer",
                transition: "all 0.2s ease",
                display: "flex",
                flexDirection: "column", // Stack Name and Price vertically
                alignItems: "center",
                justifyContent: "center",
                lineHeight: "1.2"
              }}
            >
              <span style={{ fontWeight: "bold", fontSize: "13px", textTransform: "uppercase" }}>
                {opt.name}
              </span>
              
              {/* Show Price if it exists */}
              {opt.price > 0 && (
                <span style={{ fontSize: "12px", fontWeight: "bold", opacity: isActive ? 0.8 : 0.6, marginTop: "2px" }}>
                  +${opt.price}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default SegmentedControl;